export default __webpack_public_path__ + "static/img/ig_contact_7.9e4465c.png";